// No "use client" and no hooks: works in server and client components.
import { clean_json_ld, is_empty_json_ld, json_ld_script_content } from "@core/helpers/json-ld";

// From chawk-bazar / ciseco / jument / isource / mahya / shakhe-ara, which each wrote the same `<script>` with
// `dangerouslySetInnerHTML` (several without escaping). Renders nothing for empty data (as mahya's `common/json-ld`).
// `split`: an array becomes one `<script>` per entry (jument `SchemaWidget`, chawk-bazar / ciseco / jument product page).
export const JsonLd = ({ data, id, nonce, split = false }) => {
  if (is_empty_json_ld(data)) return null;

  const clean = clean_json_ld(data);

  if (split && Array.isArray(clean)) {
    return clean.map((item, index) =>
      is_empty_json_ld(item) ? null : (
        <script
          key={index}
          id={id ? `${id}-${index}` : undefined}
          nonce={nonce}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: json_ld_script_content(item) }}
        />
      ),
    );
  }

  return <script id={id} nonce={nonce} type="application/ld+json" dangerouslySetInnerHTML={{ __html: json_ld_script_content(clean) }} />;
};

export default JsonLd;
